import { Component } from '@angular/core';

@Component({
  selector: 'lm-drawer-content',
  template: '<ng-content></ng-content>',
  styleUrls: ['./lm-drawer-content.component.scss']
})
export class LMDrawerContentComponent {}
